import React, { Children } from 'react';
import { useDroppable } from '@dnd-kit/core';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { Dropzone } from './Droppable.styles';

interface Props {
  id: string;
  bucketIndex?: number;
  children: React.ReactNode;
}

export const Droppable = ({ id, bucketIndex, children }: Props) => {
  const { isOver, setNodeRef } = useDroppable({
    id,
    data: { bucketIndex },
  });

  return (
    <Box display="flex" flexDirection="column" flex={1} ref={setNodeRef}>
      {Children.count(children) > 0 && (
        <Box as="ul" css="list-style: none" p="0" mb="16">
          {children}
        </Box>
      )}

      <Dropzone isOver={isOver}>
        <Text fontWeight={500} fontSize="small" color="neutral.400">
          Drag and drop the asset here
        </Text>
      </Dropzone>
    </Box>
  );
};
